(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-tabs-component')) {
    class ProductTabsComponent extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('[data-product-tabs-nav]');
        this.items = Array.from(this.querySelectorAll('[data-product-tabs-item]'));

        if (!this.nav || this.items.length === 0) return;

        this.items.forEach((item, index) => {
          const trigger = item.querySelector('[data-product-tabs-trigger]');
          const panel = item.querySelector('[data-product-tabs-panel]');

          if (!trigger || !panel) return;

          const uid = `${this.dataset.blockId || 'product-tabs'}-${index}`;
          trigger.id = `tab-${uid}`;
          trigger.type = 'button';
          trigger.setAttribute('role', 'tab');
          trigger.setAttribute('aria-controls', `panel-${uid}`);
          trigger.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
          trigger.setAttribute('tabindex', index === 0 ? '0' : '-1');
          trigger.classList.add('product-tabs__trigger');

          panel.id = `panel-${uid}`;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', `tab-${uid}`);
          if (index !== 0) panel.hidden = true;

          this.nav.appendChild(trigger);

          trigger.addEventListener('click', () => this.selectTab(index));
        });

        this.nav.addEventListener('keydown', (event) => this.handleKeydown(event));
      }

      selectTab(activeIndex) {
        this.items.forEach((item, index) => {
          const trigger = this.nav.children[index];
          const panel = item.querySelector('[data-product-tabs-panel]');
          const isActive = index === activeIndex;

          if (trigger) {
            trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
            trigger.setAttribute('tabindex', isActive ? '0' : '-1');
          }
          if (panel) panel.hidden = !isActive;
        });
      }

      handleKeydown(event) {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;

        const triggers = Array.from(this.nav.children);
        const currentIndex = triggers.findIndex((trigger) => trigger.getAttribute('aria-selected') === 'true');
        let newIndex = currentIndex;

        if (event.key === 'ArrowRight') newIndex = (currentIndex + 1) % triggers.length;
        if (event.key === 'ArrowLeft') newIndex = (currentIndex - 1 + triggers.length) % triggers.length;
        if (event.key === 'Home') newIndex = 0;
        if (event.key === 'End') newIndex = triggers.length - 1;

        if (newIndex !== currentIndex) {
          event.preventDefault();
          this.selectTab(newIndex);
          triggers[newIndex].focus();
        }
      }
    }

    customElements.define('product-tabs-component', ProductTabsComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
